import { theme } from '../../style/theme';

export const frostedBackgroundBlurStyle = `
    backdrop-filter: blur(0.71rem);
    -webkit-backdrop-filter: blur(0.71rem);
    background: ${theme.header.opaqueBackgroundColor} !important;
`;

/* DS `secondary navigation/Item` — shared typography/colour recipe for header nav
   links and dropdown triggers (main site + Atos Care). Layout concerns (flex,
   padding, gaps) stay at the call site.

   NOTE: the font-weight is intentionally NOT set here. Call sites must apply it
   via a ternary — `isActive ? 'font-cvi-bold' : 'font-cvi-medium'` — because
   Tailwind emits `.font-cvi-medium` after `.font-cvi-bold`, so stacking a base
   `font-cvi-medium` with an appended `font-cvi-bold` lets medium win the cascade
   and the active weight silently never applies. */
export const headerNavItemClasses = 'label-md text-cvi-fg-default self-center transition-colors duration-200 ease-in-out hover:text-cvi-fg-link';

/* Publish the header's height as `--header-height` for anything sticking below it and for the root
   `scroll-padding-top` that offsets anchor jumps. Not a constant: the content-sized header resizes on
   collapse and across breakpoints, so it is observed rather than measured once. Returns a cleanup. */
export const publishHeaderHeight = (header: HTMLElement) => {
    if (typeof ResizeObserver === 'undefined') {
        return () => {};
    }

    const publish = () => {
        const { height } = header.getBoundingClientRect();
        if (height > 0) {
            document.documentElement.style.setProperty('--header-height', `${Math.round(height)}px`);
        }
    };

    publish();

    const observer = new ResizeObserver(publish);
    observer.observe(header);

    return () => {
        observer.disconnect();
        document.documentElement.style.removeProperty('--header-height');
    };
};
